// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lvfd6","title":"styles_title__3sHEL"};